import { render } from "./TipoResponsaveis.vue?vue&type=template&id=b1da10be&scoped=true"
import script from "./TipoResponsaveis.vue?vue&type=script&lang=js"
export * from "./TipoResponsaveis.vue?vue&type=script&lang=js"

import "./TipoResponsaveis.vue?vue&type=style&index=0&id=b1da10be&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1da10be"]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QRadio from 'quasar/src/components/radio/QRadio.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTd from 'quasar/src/components/table/QTd.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QRadio,QBtn,QTable,QIcon,QTd});
